export const isFunction = (fn) =>
  fn &&
  ({}.toString.call(fn) === '[object Function]' ||
    {}.toString.call(fn) === '[object AsyncFunction]');

export default isFunction;
